import React from 'react';
import ReleaseItem, { ReleaseItemGroup } from '../../lib/models/ReleaseItem';
import { environments } from '../../lib/Known';
import ReleaseItemsViewer from './ReleaseItemsViewer';
import './Environment.scss';

interface EnvironmentProps {
    name: string;
    group: ReleaseItemGroup;
    trackedReleases: Map<string, Set<string>>;
    onToggleTrackedRelease: (releaseItem: ReleaseItem) => void;
}

interface EnvironmentState { }

export default class Environment extends React.Component<EnvironmentProps, EnvironmentState> {
    public constructor(props: EnvironmentProps) {
        super(props);
    }

    public render() {
        const starred = this.props.trackedReleases.has(this.props.name) ? this.props.trackedReleases.get(this.props.name)! : new Set<string>();

        return <div className='releaseItemGroup'>
            <h4>{this.props.name}</h4>

            <div className='envcontainer'>
                {Array.from(environments.keys()).map(env =>
                    <div className='env' key={env}>
                        <h5>{environments.get(env)}</h5>

                        <div className='itemList'>{this.props.group[env]
                            ? <ReleaseItemsViewer
                                name={this.props.name}
                                env={env}
                                starred={starred}
                                onToggleTrackedRelease={this.props.onToggleTrackedRelease}
                                items={this.props.group[env]} />
                            : 'None'}</div>
                    </div>
                )}
            </div>
        </div>
    }
}